__turbopack_context__.v({
  "circle": "ProgressBar-module__A3d6hW__circle",
  "icons": "ProgressBar-module__A3d6hW__icons",
  "label": "ProgressBar-module__A3d6hW__label",
  "noBottomMargin": "ProgressBar-module__A3d6hW__noBottomMargin",
  "numbers": "ProgressBar-module__A3d6hW__numbers",
  "step": "ProgressBar-module__A3d6hW__step",
  "stepContainer": "ProgressBar-module__A3d6hW__stepContainer",
  "stepContainerOuter": "ProgressBar-module__A3d6hW__stepContainerOuter",
  "stepIndex__1": "ProgressBar-module__A3d6hW__stepIndex__1",
  "stepIndex__2": "ProgressBar-module__A3d6hW__stepIndex__2",
  "stepIndex__3": "ProgressBar-module__A3d6hW__stepIndex__3",
  "stepIndex__4": "ProgressBar-module__A3d6hW__stepIndex__4",
  "stepIndex__5": "ProgressBar-module__A3d6hW__stepIndex__5",
  "ticks": "ProgressBar-module__A3d6hW__ticks",
  "upcoming": "ProgressBar-module__A3d6hW__upcoming",
});
